import React from "react";
import { Link } from "react-router-dom";
import { categories } from "../data/tours";
import SocialLinks from "./SocialLinks";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/logo.png"
                alt="D, Trio Trek"
                width="40"
                height="40"
                className="w-10 h-10 rounded-full"
              />
              <span className="text-xl font-bold font-display">D,&nbsp;Trio&nbsp;Trek</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Skardu, Baltistan and Hunza expeditions, run privately by a local team. Give it a try…
            </p>
            <SocialLinks />
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-5">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/tours", label: "All Tours" },
                { to: "/about", label: "About Us" },
                { to: "/contact", label: "Contact" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-accent-400 transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Tour Categories */}
          <div>
            <h3 className="font-semibold text-white mb-5">Tour Categories</h3>
            <ul className="space-y-3">
              {/* Read from the same file the tours filter reads. This was six
                  hardcoded names, half of them trips this operator does not
                  run, and every one linked to an unfiltered /tours. */}
              {categories
                .filter((cat) => cat.value !== "all")
                .map((cat) => (
                  <li key={cat.value}>
                    <Link
                      to={`/tours?category=${cat.value}`}
                      className="text-gray-400 hover:text-accent-400 transition-colors text-sm"
                    >
                      {cat.label}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-white mb-5">Get in Touch</h3>
            <ul className="space-y-4 text-sm text-gray-400">
              <li className="flex items-start space-x-3">
                <svg className="w-4 h-4 text-primary-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>Skardu & Islamabad, Pakistan</span>
              </li>
              <li className="flex items-center space-x-3">
                <svg className="w-4 h-4 text-primary-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:dtriotrek@gmail.com" className="hover:text-accent-400 transition-colors">
                  dtriotrek@gmail.com
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <svg className="w-4 h-4 text-primary-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:+923102329666" className="hover:text-accent-400 transition-colors">
                  +92 310 2329666
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between text-sm text-gray-500">
          <p>© {new Date().getFullYear()} D, Trio Trek. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            {/* Two, not three. A cookie policy on a site that sets no cookies
                advertises cookies it does not have — and all three used to be
                href="#", which is a link to nowhere in the place people look
                when they want to know how they will be treated. */}
            <Link to="/privacy" className="hover:text-accent-400 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-accent-400 transition-colors">Booking Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}